export default {
  path: '/tool_refs',
  name: 'toolrefs',
  component: () => import('../components/toolref/Layout'),
  redirect: { name: 'ToolrefList' },
  meta: {
    breadcrumb: 'tool.tools',
  },
  children: [
    {
      name: 'ToolrefList',
      path: '',
      component: () => import('../views/toolref/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'ToolrefCreate',
      path: 'new',
      component: () => import('../views/toolref/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'ToolrefUpdate',
      path: ':id/edit',
      component: () => import('../views/toolref/Update'),
      meta: {
        breadcrumb: 'tool.tool',
      },
    },
    {
      name: 'ToolrefShow',
      path: ':id',
      component: () => import('../views/toolref/Show'),
      meta: {
        breadcrumb: 'tool.tool',
      },
    }
  ]
};
